<div class="right_data_all candidateOffer">
  <div class="candidate_Details">
    <mat-card>

      <h2 class="section-title">Basic Details</h2>

      <!-- ================= BASIC DETAILS ================= -->

      <div class="basic_details">
        <div class="row basic-details-row">
          <div class="col-xxl-3 col-lg-3 col-md-4 col-sm-6 col-12 detail-item">
            <h5>Candidate Name</h5>
            <p>{{ recordData?.first_name + ' ' + recordData?.last_name }}</p>
          </div>
          <div class="col-xxl-3 col-lg-3 col-md-4 col-sm-6 col-12 detail-item">
            <h5>Email</h5>
            <p>{{ recordData?.email }}</p>
          </div>
          <div class="col-xxl-3 col-lg-3 col-md-4 col-sm-6 col-12 detail-item">
            <h5>Contact</h5>
            <p>{{ recordData?.contact_number }}</p>
          </div>
          <div class="col-xxl-3 col-lg-3 col-md-4 col-sm-6 col-12 detail-item">
            <h5>Date</h5>
            <p>{{ recordData?.createdAt | date:'dd-MM-yyyy' }}</p>
          </div>
          <div class="col-xxl-3 col-lg-3 col-md-4 col-sm-6 col-12 detail-item">
            <h5>Position</h5>
            <p>{{ recordData?.designation_name }}</p>
          </div>
          <div class="col-xxl-3 col-lg-3 col-md-4 col-sm-6 col-12 detail-item" *ngIf="recordData?.address">
            <h5>Address</h5>
            <p>{{ recordData?.address }}</p>
          </div>
          <div class="col-xxl-4 col-lg-4 col-md-6 col-sm-12 col-12 detail-item" *ngIf="!recordData?.address"
            #addressField [class.address-field-error]="submitAttempted && hasAddressError()">
            <div class="form-group address-field">
              <mat-label>Address <span class="alertspan">*</span></mat-label>
              <mat-form-field class="full-width">
                <input matInput type="text" [(ngModel)]="address" placeholder="Enter Address" required />
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- ================= DOCUMENT LOOP ================= -->

        <div class="document-row row" *ngFor="let doc of formObj.document_details; let i = index"
          #docRow [class.doc-row-error]="submitAttempted && getRowError(doc)">
          <div class="col-12 col-md-3 col-lg-3 col-xxl-3 doc-field">
            <div class="form-group">
              <mat-label>Document Name <span class="alertspan" *ngIf="doc.required">*</span></mat-label>
              <mat-form-field class="full-width">
                <input matInput type="text" [(ngModel)]="doc.document_name" [readonly]="doc.isFromChecklist"
                  (input)="removeSpaces($event)" (keypress)="preventLeadingSpace($event, doc.document_name)"
                  placeholder="Enter Document Name" [required]="doc.required" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-3 col-xxl-3 doc-field">
            <div class="form-group">
              <mat-label>Document Number <span class="alertspan" *ngIf="doc.required">*</span></mat-label>
              <mat-form-field class="full-width">
                <input matInput type="text" [(ngModel)]="doc.document_number" (input)="removeSpaces($event)"
                  (keypress)="preventLeadingSpace($event, doc.document_number)" placeholder="Enter Document Number"
                  [required]="doc.required || hasFiles(doc)" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xxl-4 doc-field doc-upload-field">
            <div class="form-group fileWithViewImgshow">
              <mat-label>Document <span class="alertspan" *ngIf="doc.required">*</span></mat-label>
              <div class="file-upload-row">
                <div class="fileRow">
                  <input class="form-control file-input candidate-file-input-hidden" type="file" multiple
                    (change)="uploadDoc($event, i)"
                    [required]="(doc.required || doc.document_number) && !hasFiles(doc)" #fileInput />
                  <button type="button" class="upload-doc-btn" (click)="fileInput.click()">
                    <mat-icon>upload</mat-icon>
                    <span>Choose files</span>
                  </button>
                  <small class="text-muted">Max file size: 5MB. You can select multiple files.</small>
                </div>
                <div class="file-list-wrap" *ngIf="getFiles(doc).length || getPaths(doc).length">
                  <!-- Newly selected files in this session -->
                  <div *ngFor="let file of getFiles(doc); let pathIdx = index" class="file-list-row">
                    <span class="file-list-name" [title]="file.name" (click)="openFileInNewTab(file)">
                      <mat-icon class="file-list-icon">insert_drive_file</mat-icon>
                      {{ file.name }}
                    </span>
                    <!-- Delete allowed for locally selected files -->
                    <button
                      type="button"
                      class="crossSideBtn"
                      (click)="removeUploadedFile(i, pathIdx); $event.stopPropagation()"
                      aria-label="Remove file">
                      ✖
                    </button>
                    <!-- Edit this specific file -->
                    <button
                      type="button"
                      class="crossSideBtn"
                      (click)="editFile(i, pathIdx, false, fileInput); $event.stopPropagation()"
                      aria-label="Edit file">
                      ✎
                    </button>
                  </div>

                  <!-- Existing files coming from API (document_path) -->
                  <div *ngFor="let path of getPaths(doc); let pathIdx = index" class="file-list-row">
                    <span class="file-list-name" [title]="path" (click)="openPathInNewTab(path)">
                      <mat-icon class="file-list-icon" *ngIf="path?.toLowerCase()?.includes('.pdf')">picture_as_pdf</mat-icon>
                      <mat-icon class="file-list-icon" *ngIf="!path?.toLowerCase()?.includes('.pdf')">image</mat-icon>
                      {{ path.split('/').pop() || path }}
                    </span>
                    <!-- Do NOT show delete for API data -->
                    <button
                      *ngIf="!doc.isFromApi"
                      type="button"
                      class="crossSideBtn"
                      (click)="removeUploadedFile(i, getFiles(doc).length + pathIdx); $event.stopPropagation()"
                      aria-label="Remove file">
                      ✖
                    </button>
                    <!-- Edit this specific API document URL (remove that URL and let user upload replacement) -->
                    <button
                      type="button"
                      class="crossSideBtn"
                      (click)="editFile(i, pathIdx, true, fileInput); $event.stopPropagation()"
                      aria-label="Edit document">
                      ✎
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-2 col-lg-2 col-xxl-2 doc-field doc-actions">
            <div class="action-buttons">
              <button type="button" class="btn btn-outline-primary btn-action" (click)="addFileControl(i)"
                title="Add document">
                <i class="fa fa-plus"></i>
              </button>
              <button type="button" class="btn btn-outline-danger btn-action" (click)="removeFileControl(i)"
                *ngIf="!doc.isFromChecklist" title="Remove row">
                <i class="material-icons">✖</i>
              </button>
              <button  *ngIf="!doc.isFromApi" type="button" class="btn btn-outline-danger btn-action" (click)="clearData(i, fileInput)"
                title="Clear">
                Clear
              </button>
            </div>
          </div>
        </div>

        <!-- ================= SUBMIT ================= -->

        <div class="common_button_sub submit-wrap mt-3 submit-area">
          <button type="submit" class="btn-submit" *ngIf="formObj.document_details?.length" (click)="handleSubmit()">
            Submit
          </button>
        </div>
      </div>
    </mat-card>
  </div>
</div>